// Compact currency formatting for the dashboard's per-company financial
// cards (turnover / profit / cash). ``value`` is a filing-derived figure
// straight from a MetricEnvelope — null (source: "unavailable") renders
// as an em dash rather than "£0" or "NaN".
export function formatMoney(
  value: number | null,
  currency: string | null,
): string {
  if (value == null) return "—";
  try {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: currency ?? "GBP",
      notation: "compact",
      maximumFractionDigits: 1,
    }).format(value);
  } catch {
    // An unrecognised/missing currency code from upstream shouldn't take
    // the whole card down — fall back to a plain compact number.
    return new Intl.NumberFormat("en-GB", {
      notation: "compact",
      maximumFractionDigits: 1,
    }).format(value);
  }
}
